<template>
    <b-tabs pills card fill justified content-class="mt-3">
        <template v-for="c in categories">
            <b-tab :title="c.categoryName" v-bind:key="c.categoryId">
                <b-container>
                    <b-button variant="primary"
                        class="mr-2 button-item"
                        v-for="i in itemsByCategory(c.categoryName)"
                        v-bind:key="i.itemId"
                        @click="handleBtnAddToCart(i)"
                    >
                        {{ itemShortName(i.itemName) }}
                    </b-button>
                </b-container>
            </b-tab>
        </template> 
    </b-tabs>
</template>

<script>
import { mapState, mapGetters } from'vuex'
export default {
    computed: {
        ...mapState({
            items: state => state.ordersbyphonecontrol.currentMenu.menuItems,
            categories: state => state.ordersbyphonecontrol.currentMenu.menuCategories
        }),
        ...mapGetters({
            itemsByCategory : 'ordersbyphonecontrol/getItemsByCategory'
        }),
        
    },
    methods : {
        handleBtnAddToCart (item) {
            this.$store.commit('ordersbyphonecontrol/addItemToCartState', item);
        },

        itemShortName( name ) {
            let itemName = name.toString();
            let index = itemName.indexOf('.');
            if (index > 0) {
                return itemName.slice(0, index+1);
            }
            return name;     
        }
    }
    

}
</script>